import React from 'react';

const Icon: React.SFC<{
  name: string;
  caption?: string;
  className?: string;
}> = props => {
  const { name, caption, className = '' } = props;
  const iconName = `icon-${name}`;
  return <i className={`${iconName} ${className}`} title={caption} />;
};

export default Icon;
